(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ydl-custom-options"] && !Shopify.designMode) return;
  try {
    const initializeYdlCustomOptions = (root) => {
    if (root.dataset.initialized === 'true') {
      return;
    }

    root.dataset.initialized = 'true';

    const form = root.closest('form');
    const selects = Array.from(root.querySelectorAll('select'));
    const connectorSelect = root.querySelector('[data-ydl-connector-select]');
    const connectorThumb = root.querySelector('[data-ydl-connector-thumb]');
    const connectorThumbImage = connectorThumb ? connectorThumb.querySelector('img') : null;
    const connectorThumbBadge = root.querySelector('[data-ydl-thumb-badge]');
    const ntcSelect = root.querySelector('[data-ydl-ntc-select]');
    const polarityGroup = root.querySelector('[data-ydl-polarity-group]');
    const polarityInputs = Array.from(root.querySelectorAll('[data-ydl-polarity]'));
    const polarityHint = root.querySelector('[data-ydl-polarity-hint]');
    const minimumMessage = root.querySelector('[data-ydl-custom-minimum]');
    const orderButton = form ? form.querySelector('[data-action="add-to-cart"]') : null;
    const failedImages = new Set();

    if (!form || selects.length === 0 || !minimumMessage) {
      return;
    }

    const BASE_MINIMUM = 4;
    const NTC_MINIMUM = 10;

    const selectedConnectorOption = () => (connectorSelect
      ? connectorSelect.options[connectorSelect.selectedIndex]
      : null);
    const isReversed = () => polarityInputs.some((input) => input.checked && input.value !== '');
    const isCustomized = () => selects.some((select) => select.value !== '') || isReversed();
    const minimumQuantity = () => {
      const option = selectedConnectorOption();
      const connectorMinimum = option ? Number.parseInt(option.dataset.moq, 10) || 0 : 0;
      const ntcMinimum = ntcSelect && ntcSelect.value !== '' ? NTC_MINIMUM : 0;

      return Math.max(BASE_MINIMUM, connectorMinimum, ntcMinimum);
    };
    const quantityInput = () => form.querySelector('input[name="quantity"]');
    const decreaseButton = () => form.querySelector('[data-action="decrease-picker-quantity"]');

    let quantityState = null;
    let decreaseState = null;
    let lastMinimum = null;

    const syncOrderButtonText = () => {
      if (orderButton && !orderButton.disabled) {
        orderButton.textContent = isCustomized() ? 'Order Custom' : 'Order Standard';
      }
    };

    const syncPolarityAvailability = () => {
      const option = selectedConnectorOption();
      const noPolarity = Boolean(option && option.hasAttribute('data-no-polarity'));

      if (noPolarity) {
        polarityInputs.forEach((input) => {
          input.checked = input.value === '';
        });
      }

      if (polarityGroup) {
        polarityGroup.hidden = noPolarity;
      }

      if (polarityHint) {
        polarityHint.hidden = noPolarity;
      }
    };

    const syncPolarityHint = () => {
      if (polarityHint) {
        polarityHint.textContent = isReversed()
          ? polarityHint.dataset.hintReversed
          : polarityHint.dataset.hintStandard;
      }
    };

    const syncConnectorThumb = () => {
      if (!connectorThumb || !connectorThumbImage) {
        return;
      }

      const option = selectedConnectorOption();
      const src = option
        ? (isReversed() ? option.dataset.imageReversed : option.dataset.image) || ''
        : '';
      if (!src || failedImages.has(src)) {
        connectorThumb.hidden = true;
        return;
      }

      if (connectorThumbImage.getAttribute('src') !== src) {
        connectorThumbImage.src = src;
        connectorThumbImage.alt = option.text;
        connectorThumb.href = src;
        connectorThumb.title = option.text;
      }

      if (connectorThumbBadge) {
        connectorThumbBadge.hidden = !isReversed();
      }

      connectorThumb.hidden = false;
    };

    if (connectorThumbImage) {
      connectorThumbImage.addEventListener('error', () => {
        failedImages.add(connectorThumbImage.getAttribute('src'));
        connectorThumb.hidden = true;
      });
    }

    const syncDecreaseButton = () => {
      const quantity = quantityInput();
      const button = decreaseButton();

      if (!quantity || !button) {
        return;
      }

      const minimum = minimumQuantity();
      if (!minimum) {
        if (decreaseState && decreaseState.button === button && button.disabled === decreaseState.applied) {
          button.disabled = decreaseState.disabled;
          if (decreaseState.aria === null) {
            button.removeAttribute('aria-disabled');
          } else {
            button.setAttribute('aria-disabled', decreaseState.aria);
          }
        }
        decreaseState = null;
        return;
      }

      if (!decreaseState || decreaseState.button !== button) {
        decreaseState = { button, disabled: button.disabled, aria: button.getAttribute('aria-disabled') };
      }
      const currentQuantity = Number.parseInt(quantity.value, 10) || 1;
      button.disabled = decreaseState.disabled || currentQuantity <= minimum;
      decreaseState.applied = button.disabled;
      button.setAttribute('aria-disabled', button.disabled ? 'true' : 'false');
    };

    const syncCustomization = () => {
      syncPolarityAvailability();

      const minimum = minimumQuantity();
      const custom = minimum > 1;
      const quantity = quantityInput();

      minimumMessage.hidden = !custom;
      minimumMessage.textContent = minimumMessage.dataset.template.replace('{n}', String(minimum));

      if (quantity) {
        if (custom) {
          if (!quantityState || quantityState.input !== quantity) {
            quantityState = { input: quantity, original: quantity.getAttribute('min'), applied: null };
          } else if (quantityState.applied !== null && quantity.getAttribute('min') !== quantityState.applied) {
            quantityState.original = quantity.getAttribute('min');
          }
          quantityState.applied = String(Math.max(minimum, Number.parseInt(quantityState.original, 10) || 1));
          quantity.min = quantityState.applied;
        } else if (quantityState) {
          if (quantityState.input === quantity && quantity.getAttribute('min') === quantityState.applied) {
            if (quantityState.original === null) {
              quantity.removeAttribute('min');
            } else {
              quantity.setAttribute('min', quantityState.original);
            }
          }
          quantityState = null;
        }

        const currentQuantity = Number.parseInt(quantity.value, 10) || 0;
        const belowMinimum = currentQuantity < minimum;
        const leftAtOldMinimum = lastMinimum !== null && currentQuantity === lastMinimum && minimum < lastMinimum;

        if (custom && (belowMinimum || leftAtOldMinimum)) {
          quantity.value = String(minimum);
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        }

        lastMinimum = minimum;
      }

      syncConnectorThumb();
      syncPolarityHint();
      syncDecreaseButton();
      syncOrderButtonText();
    };

    selects.forEach((select) => select.addEventListener('change', syncCustomization));
    polarityInputs.forEach((input) => input.addEventListener('change', syncCustomization));

    form.addEventListener('click', (event) => {
      const decrease = event.target.closest('[data-action="decrease-picker-quantity"]');
      const quantity = quantityInput();
      const minimum = minimumQuantity();

      if (decrease && quantity && minimum > 1 && (Number.parseInt(quantity.value, 10) || 0) <= minimum) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      window.requestAnimationFrame(syncDecreaseButton);
    }, true);

    form.addEventListener('change', (event) => {
      const minimum = minimumQuantity();

      if (event.target.matches('input[name="quantity"]') && minimum > 1) {
        const enteredQuantity = Number.parseInt(event.target.value, 10) || 0;

        if (enteredQuantity < minimum) {
          event.target.value = String(minimum);
        }

        syncDecreaseButton();
      }
    });

    form.addEventListener('submit', (event) => {
      const quantity = quantityInput();
      const minimum = minimumQuantity();

      if (quantity && minimum > 1 && (Number.parseInt(quantity.value, 10) || 0) < minimum) {
        event.preventDefault();
        event.stopImmediatePropagation();
        quantity.value = String(minimum);
        quantity.focus();
        minimumMessage.hidden = false;
      }
    }, true);

    syncCustomization();
  };

  document.querySelectorAll('[data-ydl-custom-options]').forEach(initializeYdlCustomOptions);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-ydl-custom-options]').forEach(initializeYdlCustomOptions);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ydl-volume-pricing"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (root) => {
      if (root.dataset.ydlVolumePricingReady === 'true') return;

      const data = root.querySelector('[data-ydl-variant-prices]');
      const form = root.closest('form[action*="/cart/add"]') || root.closest('.product-form');
      if (!data || !form) return;

      let prices;
      try {
        prices = JSON.parse(data.textContent);
      } catch {
        return;
      }

      const update = () => {
        const variantInput = form.querySelector('[name="id"]');
        const cents = prices[String(variantInput?.value)];
        if (!Number.isFinite(cents)) return;

        const currency = root.dataset.currency;
        const locale = root.dataset.locale || document.documentElement.lang || 'en';
        const formatter = new Intl.NumberFormat(locale, {
          style: 'currency',
          currency
        });

        root.querySelectorAll('[data-ydl-tier-price]').forEach((price) => {
          const discount = Number(price.dataset.discount);
          const discountedCents = cents - Math.floor(cents * discount / 100);
          price.textContent = `${formatter.format(discountedCents / 100)} ${currency}`;
        });
      };

      form.addEventListener('change', update);
      update();
      root.dataset.ydlVolumePricingReady = 'true';
    };

    const initializeAll = () => {
      document.querySelectorAll('[data-ydl-volume-pricing]').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    } else {
      initializeAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
